// calm background music generated in the browser (no copyright issues when sharing)
const N = (m) => 440 * 2 ** ((m - 69) / 12);
export const MOODS = {
  mountain: { chords: [[57, 64, 69, 72], [53, 60, 65, 69], [55, 62, 67, 71], [52, 59, 64, 67]], bell: [69, 72, 74, 76, 79], wave: 'sine', cut: 1400 },
  forest: { chords: [[60, 67, 72, 76], [57, 64, 69, 72], [65, 69, 72, 77], [62, 67, 71, 74]], bell: [72, 74, 76, 79, 81], wave: 'triangle', cut: 1800 },
  evening: { chords: [[50, 57, 62, 65], [46, 53, 58, 62], [48, 55, 60, 64], [45, 52, 57, 60]], bell: [62, 65, 67, 69, 72], wave: 'sine', cut: 900 },
};
export const MOOD_KEYS = Object.keys(MOODS);

export function startAmbient(ctx, out, mood) {
  const M = MOODS[mood] || MOODS.mountain, bus = ctx.createGain(), lp = ctx.createBiquadFilter(), dl = ctx.createDelay(1.5), fb = ctx.createGain();
  bus.gain.value = 0.0001; bus.gain.exponentialRampToValueAtTime(0.5, ctx.currentTime + 2);
  lp.type = 'lowpass'; lp.frequency.value = M.cut; dl.delayTime.value = 0.42; fb.gain.value = 0.35;
  bus.connect(lp); lp.connect(out); lp.connect(dl); dl.connect(fb); fb.connect(dl); dl.connect(out);
  const tone = (f, at, len, vol, wave) => {
    const o = ctx.createOscillator(), g = ctx.createGain();
    o.type = wave; o.frequency.value = f; o.detune.value = (Math.random() - 0.5) * 8;
    g.gain.setValueAtTime(0.0001, at); g.gain.exponentialRampToValueAtTime(vol, at + Math.min(1.5, len / 3)); g.gain.exponentialRampToValueAtTime(0.0001, at + len);
    o.connect(g); g.connect(bus); o.start(at); o.stop(at + len + 0.1);
  };
  let i = 0, next = ctx.currentTime + 0.1;
  const plan = () => {
    while (next < ctx.currentTime + 3) {
      const c = M.chords[i % M.chords.length];
      c.forEach((m) => tone(N(m), next, 4.6, 0.05, M.wave));
      tone(N(c[0] - 12), next, 4.6, 0.06, 'sine');
      for (let k = 0; k < 3; k++) if (Math.random() < 0.55) tone(N(M.bell[Math.floor(Math.random() * M.bell.length)]), next + k * 1.3 + Math.random() * 0.3, 2.2, 0.035, 'sine');
      next += 4; i += 1;
    }
  };
  plan();
  const iv = setInterval(plan, 1000);
  return () => { clearInterval(iv); bus.gain.cancelScheduledValues(ctx.currentTime); bus.gain.setValueAtTime(bus.gain.value, ctx.currentTime); bus.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 1.2); setTimeout(() => bus.disconnect(), 1500); };
}

// own music file from the phone: decoded and looped
export async function startFile(ctx, out, file) {
  const buf = await ctx.decodeAudioData(await file.arrayBuffer()), src = ctx.createBufferSource(), g = ctx.createGain();
  src.buffer = buf; src.loop = true; g.gain.value = 0.8; src.connect(g); g.connect(out); src.start();
  return () => { g.gain.setValueAtTime(g.gain.value, ctx.currentTime); g.gain.linearRampToValueAtTime(0, ctx.currentTime + 1); setTimeout(() => src.stop(), 1100); };
}
